
export const STEPS = {
    upload: 'upload',
    card: 'card'
};

